<template>
  <div
    class="like-icon"
    @click="collectHandle"
  >
    <img
      v-if="isLike"
      src="@/assets/images/layout/icon_pre_shoucang .png"
    >
    <img
      v-else
      src="@/assets/images/layout/icon_nor_weishoucang.png"
    >
  </div>
</template>

<script>
import CollectMixin from '@/mixins/collect/collect';

export default {
  name: 'LikeIcon',
  mixins: [CollectMixin],
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    isLike() {
      return this.collectList.find(item => item.menuId == this.name)
        ? true
        : false;
    },
  },
  methods: {
    collectHandle() {
      if (this.isLike) {
        this.delCollect({
          id: this.name,
        });
      } else {
        this.addCollect({
          menuId: this.name,
        });
      }
    },
  },
};
</script>

